import { defineComponent as _defineComponent } from 'vue'
import { ref, computed, inject } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import useGlobal from '@/composables/useGlobal'
import { GET_BREADCRUMBS_INNER_LABELS } from '@/components/conts'


export default /*@__PURE__*/_defineComponent({
  __name: 'SimpleBreadcrumbs',
  setup(__props, { expose: __expose }) {
  __expose();

const { $t } = useGlobal()
const route = useRoute()
const router = useRouter()
const currentTitle = inject('currentTitle')

const objectId = computed(() => route?.params?.id || null)
const parentRouteName = computed(() => route?.meta?.parent || null)

const DROPPED_KEYS = ['cabinet', window.language, ]

const breadcrumbs = computed(() => {
  const paths = route.path.split('/').filter(Boolean)
  return paths.map((path, index) => {
    if (!DROPPED_KEYS.includes(path) && isNaN(path)) {
      const url = ('/' + paths.slice(0, index + 1).join('/') + '/').replace('//', '/')
      return { name: path, url, path: route.matched.find(e => e.path == url) }
    }
    return null
  }).filter(Boolean)
})

const labels = ref(GET_BREADCRUMBS_INNER_LABELS($t))


const __returned__ = { $t, route, router, currentTitle, objectId, parentRouteName, DROPPED_KEYS, breadcrumbs, labels, ref, computed, inject, get useRoute() { return useRoute }, get useRouter() { return useRouter }, get useGlobal() { return useGlobal }, get GET_BREADCRUMBS_INNER_LABELS() { return GET_BREADCRUMBS_INNER_LABELS } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})